import type { PayloadAction } from '@reduxjs/toolkit';
import type { CampaignEditorReducerCreator } from '../types';
import { updateBlock } from '../helpers';

// value === undefined clears the key, reverting that property back to the template's own default
const updateBlockStyle = (create: CampaignEditorReducerCreator) =>
  create.reducer((state, action: PayloadAction<{ blockId: string; key: string; value: unknown }>) => {
    const { blockId, key, value } = action.payload;
    updateBlock(state, blockId, (block) => {
      const nextStyle = { ...block.style, [key]: value };
      if (value === undefined) delete nextStyle[key];
      return { ...block, style: nextStyle };
    });
  });

export default updateBlockStyle;
